<div class="around-chart">
  <canvas #canvas width="600" height="300">

  </canvas>
</div>
